export default __webpack_public_path__ + "static/chirp-58d503b2df87082ceeb14f21080996f4.svg";